// extracted by mini-css-extract-plugin
export var chevronIcon = "_d4-2";
export var teamName = "_d4-1";
export var teamSwitcherButton = "_d4-0";